export default __webpack_public_path__ + "static/media/img_major03_sub1.7bf3956f.png";